module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/openweather-weathercodes/50d-e61faee5b9692f9897af7717913dd7e3.svg";